import { AxiosRequestConfig } from "axios";
import { ApiService } from "../config";
import { handleError } from "../utils/parseApiReturn";
import { toast } from "react-toastify";

export interface CategoryOption {
  id: number;
  name: string;
}

const searchCategories = async (token: string, query: string): Promise<CategoryOption[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: { Authorization: `Bearer ${token}` },
      params: { q: query },
    };
    const result = await ApiService.get("/categories/search", config);
    const { data, error } = result.data;
    if (error) {
      const { message } = handleError(error, "Erro ao buscar categorias");
      toast.error(message);
      return [];
    }
    return data ?? [];
  } catch (error) {
    const { message } = handleError(error, "Erro inesperado ao buscar categorias");
    toast.error(message);
    return [];
  }
};

export const CategoriesService = { searchCategories };
